export default __webpack_public_path__ + "static/media/square_register.90aa5480.png";